export default "__VITE_ASSET__CCOp2wJR__"